module.exports = __webpack_public_path__ + "img/elton-john.82c3425e.jpg";